/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetFamilyMemberTemporaryPinCodesPathParameters } from 'api/actions/get-family-member-temporary-pin-codes/get-family-member-temporary-pin-codes-path-parameters';
import { GetFamilyMemberTemporaryPinCodesResponse } from 'api/actions/get-family-member-temporary-pin-codes/get-family-member-temporary-pin-codes-response';

type GetFamilyMemberTemporaryPinCodesQueryParameters = Record<string, any>;

/**
 * The path of the GetFamilyMemberTemporaryPinCodes action.
 */
export const getFamilyMemberTemporaryPinCodesActionPath = new SweetPath<
  keyof GetFamilyMemberTemporaryPinCodesPathParameters
>('/user/family/members/{userId}/pin/temporary', { path: '{param}' });

/**
 * Creates a contextualized GetFamilyMemberTemporaryPinCodes actions.
 */
export default function createGetFamilyMemberTemporaryPinCodesAction(axios: AxiosInstance) {
  return function getFamilyMemberTemporaryPinCodesAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetFamilyMemberTemporaryPinCodesPathParameters;
    query?: GetFamilyMemberTemporaryPinCodesQueryParameters;
  }) {
    const path = getFamilyMemberTemporaryPinCodesActionPath.insert(parameters);

    return axios.get<GetFamilyMemberTemporaryPinCodesResponse, GetFamilyMemberTemporaryPinCodesResponse>(path, {
      params: query,
      headers,
    });
  };
}
